import _ from "lodash";
import { IStep } from "../../types/commonTypes";
import { INVALID_EMAIL } from "../../constants/textConstants";

export const sum = (a: number, b: number) => a + b;

export const getNextSteps = (steps: IStep[], currentStep: number, isEditMode?: boolean) => {
  const nextStep = isEditMode ? 4 : currentStep + 1;
  return _.map(steps, (step: IStep) => {
    if (step.step === currentStep) {
      return { ...step, completed: true, active: false };
    } else if (step.step === nextStep) {
      return { ...step, active: true };
    }
    return { ...step, active: false };
  });
};

export const handleScript = (ref: any, param: string) => {
  // Clear existing content
  if (!ref.current) return;
  ref.current.innerHTML = '';

  // Create a script element
  const script = document.createElement('script');
  script.type = 'text/javascript';

  const targetUrl = window.location.host.includes('uat')
    ? 'https://uat.citigroup.com/'
    : 'https://www.citigroup.com/';

  const scriptCode = `
    try {
      var postObject = JSON.stringify({ event: "${param}" });
      window.parent.postMessage(postObject, "${targetUrl}");
      console.log('Message sent to parent window');
    } catch(e) {
      window.console && window.console.log(e);
    }
  `;

  script.text = scriptCode;

  // Append script directly so it executes
  ref.current.appendChild(script);
};

export const getBackSteps = (steps: IStep[], currentStep: number) => {
  return _.map(steps, (step: IStep) =>
    step.step === currentStep - 1 ? { ...step, active: true } : { ...step, active: false }
  );
};

export const convertCapitalizeWords = (word: string) => {
  const splitArray = !Array.isArray(word) ? word.split(" ") : word;
  const capitalizedWords = _.map(splitArray, (w) => _.capitalize(w));
  return capitalizedWords.join(" ");
};

export const changeStyle = (isMobileClass: string, isDesktopClass: string) => {
  if (window.innerWidth <= 768) {
    return isMobileClass;
  } else if (window.innerWidth >= 768) {
    return isDesktopClass;
  }
};

export const getSelectedValue = (companyInfo: any, staticData: any) => {
  const selectedCountryName = companyInfo?.global_ultimate_country_name;
  // (companyInfo?.global_ultimate_country_name &&
  //   convertCapitalizeWords(companyInfo.global_ultimate_country_name)) ??
  // "";
  const selectedJurisdictions = companyInfo?.operatedCountry;
  const selectedIndustry = companyInfo?.industry ?? "";
  const countries = _.keys(staticData.countries);
  const IndustrySales = staticData.countries?.[selectedCountryName]?.industry ?? [];
  const Industries = selectedCountryName && IndustrySales ? _.keys(IndustrySales) : [];
  //const IndustrialKey:any = selectedIndustry && Object.keys(IndustrySales).find(k => k.startsWith(selectedIndustry) || k.endsWith(selectedIndustry));
  const SalesSize =
    Industries.length === 1
      ? Industries[0]
        ? IndustrySales[Industries[0]]
        : []
      : selectedIndustry
        ? _.values(IndustrySales[selectedIndustry])
        : [];

  return {
    selectedCountryName: selectedCountryName,
    IndustrialKey: selectedIndustry,
    selectedJurisdictions: selectedJurisdictions,
    selectedIndustry: selectedIndustry,
    countries: countries,
    Industries: Industries,
    SalesSize: SalesSize,
  };
};

export const validateSaleSize = (companyInfo: any) => {
  if (companyInfo?.salesSize === "Pre-Revenue") {
    return companyInfo?.isCompanyVCorPEBacked;
  }
  delete companyInfo?.isCompanyVCorPEBacked;
  return companyInfo?.salesSize;
};

export const validateWebsite = (item: any) => {
  const regex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
  if (item && !regex.test(item)) {
    return "Please enter a valid URL";
  }
  return "";
};

export const validateLead = (
  item: any,
  data: any,
  updatedData: any,
  itemValue: any,
  indexValue: any
) => {
  switch (item) {
    case "factor":
      updatedData[itemValue][indexValue].factor = data.value;
      break;
    case "score":
      updatedData[itemValue][indexValue].score = data.value;
      break;
    case "editable":
      updatedData[itemValue][indexValue].editable = data.checked;
      break;
    case "applicable":
      updatedData[itemValue][indexValue].applicable = data.checked;
      break;
  }
  return updatedData;
};

export const createLeadData = (
  item: any,
  data: any,
  updatedData: any,
  itemValue: any,
  indexValue: any
) => {
  switch (item) {
    case "name":
      updatedData[itemValue][indexValue].factor = data.value;
      break;
    case "factor":
      updatedData[itemValue][indexValue].factor = data.value;
      break;
    case "score":
      updatedData[itemValue][indexValue].score = data.value;
      break;
    case "editable":
      updatedData[itemValue][indexValue].editable = data.checked;
      break;
    case "applicable":
      updatedData[itemValue][indexValue].applicable = data.checked;
      break;
  }
  return updatedData;
};

export const handleInvalidFieldValidation = (ddName: any, item: any) => {
  switch (ddName) {
    case "title":
      return !/^[a-zA-Z]+$/.test(item);
      break;
    case "name":
      return !/^[a-zA-Z]+$/.test(item);
      break;
    case "factor":
      return !/^-?[0-9]+$/.test(item);
      break;
    case "score":
      return !/^-?[0-9]+$/.test(item);
      break;
  }
};

export const handleErrorMessage = (item: any) => {
  const { title, name, factor, score, invalidFactor, invalidScore } = item;
  const errorMessages = [];
  if (name == "") {
    errorMessages.push("criteria");
  }
  if (title == "") {
    errorMessages.push("category");
  }
  if (score == "" || invalidScore) {
    errorMessages.push("score");
  }
  if (factor == "" || invalidFactor) {
    errorMessages.push("factor");
  }
  return errorMessages.length > 0 ? `Please enter valid ${errorMessages.join(", ")}` : "";
};

export const countChanges = (updatedData: any, originalData: any) => {
  const changes: any = {};
  const updatedItemChanged: any = {};
  for (const key in originalData) {
    updatedItemChanged[key] = [];
    if (
      Object.prototype.hasOwnProperty.call(originalData, key) &&
      Object.prototype.hasOwnProperty.call(updatedData, key)
    ) {
      const originalArray = originalData[key];
      const updatedArray = updatedData[key];
      if (Array.isArray(originalArray) && Array.isArray(updatedArray)) {
        let changeCount = 0;
        const maxLength = Math.max(originalArray.length, updatedArray.length);
        for (let i = 0; i < maxLength; i++) {
          if (JSON.stringify(originalArray[i]) !== JSON.stringify(updatedArray[i])) {
            updatedItemChanged[key].push(i);
            changeCount++;
          }
        }
        if (changeCount > 0) {
          changes[key] = changeCount;
        }
      }
    }
  }
  return { changes, updatedItemChanged };
};

const checkEveryField = (item: any) => {
  return item.every(
    (itemValue: any) =>
      itemValue.name !== undefined &&
      itemValue.name !== null &&
      itemValue.name !== "" &&
      itemValue.score !== undefined &&
      itemValue.score !== null &&
      itemValue.score !== "" &&
      itemValue.applicable !== undefined &&
      itemValue.applicable !== null &&
      itemValue.factor !== undefined &&
      itemValue.factor !== null &&
      itemValue.factor !== "" &&
      itemValue.editable !== undefined &&
      itemValue.editable !== null
  );
};

export const isValidateField = (item: any) => {
  const keys: any = Object.keys(item);
  let i;
  let allFieldValidated = false;
  for (i = 0; i < keys.length; i++) {
    if (checkEveryField(item[keys[i]])) {
      allFieldValidated = true;
    } else {
      return false;
    }
  }
  return allFieldValidated;
};

export const updateObject = (obj: any, target: any) => {
  for (const key in obj) {
    if (obj[key] && typeof obj[key] === "object") {
      if (obj[key].category === target.category && obj[key].criteria === target.criteria) {
        obj[key] = { ...obj[key], ...target };
      } else {
        updateObject(obj[key], target);
      }
    }
  }
  return obj;
};

export const calculateTotalScore = (data: any) => {
  let totalScore = 0;

  const calculateScore = (obj: any) => {
    for (const key in obj) {
      if (Array.isArray(obj[key])) {
        obj[key].forEach((item: any) => {
          if (item.score !== undefined) {
            totalScore += Number(item.score);
          }
        });
      } else if (typeof obj[key] === "object") {
        calculateScore(obj[key]);
      } else if (key === "score" && obj[key] !== undefined) {
        totalScore += Number(obj[key]);
      }
    }
  };

  calculateScore(data);
  data["finalLeadScore"] = totalScore;
  return data;
};

export const findChangedProperties = (originalData: any, updatedData: any) => {
  const changes: any = [];
  const updatedItemChanged: any = [] as any;
  const compare = (original: any, updated: any, path = "") => {
    for (const key in original) {
      if (key == "webLeadRequestId") {
        updatedItemChanged.push(original[key]);
      }
      if (original[key] && typeof original[key] === "object") {
        compare(original[key], updated[key], path + key + ".");
      } else if (original[key] !== updated[key]) {
        updated["category"] &&
          updated["criteria"] &&
          changes.push({
            category: updated["category"],
            criteria: updated["criteria"],
            webLeadRequestId: updatedItemChanged[path.split(".")[0]],
          });
      }
    }
  };
  compare(originalData, updatedData);
  return getUniqueObjects(changes);
};

function getUniqueObjects(array: any) {
  return array.filter(
    (value: any, index: any, self: any) =>
      self.findIndex(
        (v: any) =>
          v.category === value.category &&
          v.criteria === value.criteria &&
          v.webLeadRequestId === value.webLeadRequestId
      ) === index
  );
}

export const removePropChange = (obj: any): any => {
  if (Array.isArray(obj)) {
    return obj.map(removePropChange);
  } else if (obj !== null && typeof obj === "object") {
    const newObj = { ...obj };
    if (newObj?.editEnable !== undefined) {
      newObj.editEnable = false;
    }
    if (newObj?.editable !== undefined) {
      newObj.editable = false;
    }
    Object.keys(newObj).forEach((key) => {
      newObj[key] = removePropChange(newObj[key]);
    });
    return newObj;
  }
  return obj;
};

export const validateScores = (data: any): boolean => {
  if (Array.isArray(data)) {
    return data.every((item) => validateScores(item));
  } else if (typeof data === "object" && data !== null) {
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        if (
          key === "score" &&
          (data[key] === null || data[key] === undefined || data[key] === "")
        ) {
          return false;
        }
        if (!validateScores(data[key])) {
          return false;
        }
      }
    }
  }
  return true;
};

export const checkErrorForPhoneAndEmail = (invalidPhone: string, invalidEmail: string | null) => {
  if (invalidPhone) {
    return [invalidPhone];
  } else if (invalidEmail === INVALID_EMAIL) {
    return [invalidEmail];
  }
  return [];
};

export const validateInputField = (data: any, type = ""): boolean => {
  if (Array.isArray(data) && data.length === 0) {
    return false;
  }
  if (data === undefined || data === null || data === "") {
    return false;
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const mobileRegex = /^\d{10}$/; // Adjust the regex based on the required mobile number format
  const zipcodeRegex = /^[a-zA-Z0-9]{1,20}$/;
  const websiteRegex =
    /^(https?:\/\/)(www\.)?([a-zA-Z0-9_-]+\.)+[a-zA-Z]{2,}((\/[\w#-]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?)?\/?$/;
  const websiteWithWWWRegex =
    /^(https?:\/\/)?www\.([a-zA-Z0-9_-]+\.)+[a-zA-Z]{2,}(\/[a-zA-Z0-9#_-]+)*(\/[a-zA-Z0-9#_-]+\?[a-zA-Z0-9_]+=[a-zA-Z0-9_]+(&[a-zA-Z0-9_]+=[a-zA-Z0-9_]+)*)?\/?$/;

  switch (type) {
    case "email":
      return emailRegex.test(data);
    case "mobile":
      console.log("mobileRegex.test(data)", mobileRegex.test(data.replace(/\D/g, "")));
      return mobileRegex.test(data.replace(/\D/g, ""));
    case "zipcode":
      return zipcodeRegex.test(data);
    case "website":
      return websiteRegex.test(data) || websiteWithWWWRegex.test(data);
    case "textArea":
      return data.length >= 80;
    default:
      return true;
  }
};

export const detectZoom = () => {
  let ratio = 0;
  const screen = window.screen;
  const  ua = navigator.userAgent.toLowerCase();
  if (window.devicePixelRatio !== undefined) {
    ratio = window.devicePixelRatio;
  } else if (~ua.indexOf("msie")) {
    if ((screen as any).deviceXDPI && (screen as any).logicalXDPI) {
      ratio = (screen as any).deviceXDPI / (screen as any).logicalXDPI;
    }
  } else if (
    window.outerWidth !== undefined &&
    window.innerWidth !== undefined
  ) {
    ratio = window.outerWidth / window.innerWidth;
  }
  if (ratio) {
    ratio = Math.round(ratio * 100);
  }
  return ratio;
};